import { render, staticRenderFns } from "./EbookDetail.vue?vue&type=template&id=37f453c7&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./EbookDetail.vue?vue&type=script&lang=js&"
export * from "./EbookDetail.vue?vue&type=script&lang=js&"
import style0 from "./EbookDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EbookDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports